module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9jocn"))).then(() => parcelRequire('2KbAe'));